import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import config from '../../../../../../config';
import storage from '../../../../../../hooks/useStorage/useStorage';
import { useApplicationContext } from '../../../../../context/ApplicationContext/ApplicationContext';
import { ClientSocket } from './useChatWebsocket.types';

const useChatWebsocket = () => {
  const { team } = useApplicationContext();
  const [chatSocket, setChatSocket] = useState<ClientSocket | null>(null);

  useEffect(() => {
    if (!team) {
      return;
    }

    const clientSocket = io(`${config.websocketChatUrl}/chats`, {
      path: '/ws/chats',
      transports: ['websocket'],
      auth: {
        teamId: storage.getTeamId(),
        brandId: storage.getBrandId(),
        token: storage.getSessionId(),
        adminTeamId: storage.getAdminTeamId(),
      },
    });

    setChatSocket(clientSocket);

    return () => {
      clientSocket.close();
      setChatSocket(null);
    };
  }, [team?.id]);

  return chatSocket;
};

export default useChatWebsocket;
